module.exports = __webpack_public_path__ + "img/nfpoa-tela03_corte.bfefc6f1.png";